import './sentry'; // must be first — captures errors from all subsequent imports
import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import "./App.css";
import "./styles/header.css";
import "./styles/components.css";
import "./styles/forms.css";
import "./styles/buttons.css";
import "./styles/layout.css";
import "./styles/utilities.css";
import "./styles/animations.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { register as registerSW } from "./serviceWorkerRegistration";
import { Provider } from "react-redux";
import store from "./app/store";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <React.StrictMode>
      <App />
    </React.StrictMode>
  </Provider>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
registerSW();
